import config from "appConfig";
import { LayoutComponents } from "@jelly/lesson";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [1, 5],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Lining on separating wall only",
                    formatter: "simple",
                    scrollbars: false,
                    styles: {
                      fontWeight: 800,
                      fontSize: "14px",
                      letterSpacing: "3.5px",
                      textTransform: "uppercase",
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/28/principle/principle-2-massive.svg`,
                  },
                },
                styles: {
                  width: "80%",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
